// Component: الخدمات المطلوبة
import { useLanguage } from "../../../i18n/LanguageContext";

export default function ServicesSelector({
  selectedServices,
  onCheckboxChange,
}) {
  const { t } = useLanguage();

  return (
    <div className="request-services-box">

      {/* العنوان */}
      <label className="request-label">
        {t.request.labels.services}
      </label>

      {/* الخدمات */}
      {t.request.services.map((service, index) => (
        <label key={index} className="request-option">
          <input
            type="checkbox"
            value={service}
            checked={selectedServices.includes(service)}
            onChange={onCheckboxChange}
          />
          {service}
        </label>
      ))}

    </div>
  );
}

